import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from 'src/app/features/promotions/promotions.service';
import { ProvidersService } from '../providers.service';

@Component({
  selector: 'app-map-pricelist-smart',
  template: `<app-map-pricelist [tiers]="tiers" [countries]="countries" [codeGroups]="codeGroups" [loyalityRewardsData]="loyalityRewardsData"></app-map-pricelist>`,
  styleUrls: ['./map-pricelist.component.scss']
})
export class MapPricelistSmartComponent extends FeaturesBaseComponent implements OnInit {
  loyalityRewardsData: any = [];
  codeGroups: any[] = [];
  countries: any[] = [];
  tiers: any[] = [];
  constructor(private promotionService: PromotionsService, private providersService: ProvidersService) {
    super();

    this.getAllData()

  }
  getAllData() {

    this.providersService.getsalesrepsPricelists().subscribe(
      res => this.codeGroups = res['data']
    )
    this.providersService.getretailerPricelists().subscribe(
      res => this.countries = res['data']
    )
    // this.providersService.getconsumerpricelists().subscribe(
    //   {next:(res) => {
    //     console.log('res',res)
    //     let resData = res['data']
    //       resData.forEach((val) => {
    //         console.log(val)
    //         this.countries.push(val)
    //       })
    //       console.log('countires',this.countries)
    //     //  this.countries = res['data']
    //   }}
    // )
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
